export default {
    backtop: "返回頂部",
    hot: "人氣商品",
    more: "查看更多",
    nothing: "暫無商品",
    hotGoods: "熱門",
    instructions: "產品使用說明"
}